/*  PATIENT TEST APPOINTMENTtS */

export const GET_LAB_NAMES_LIST =
  "GET_LAB_NAMES_LIST";
export const GET_LAB_NAMES_LIST_SUCCESS =
  "GET_LAB_NAMES_LIST_SUCCESS";
export const GET_LAB_NAMES_LIST_FAIL =
  "GET_LAB_NAMES_LIST_FAIL";
